import { initClearRefinementsWidget} from "./algolia-clear-refinements-component.js";
import { initCourseStatusesRefinementList } from "./algolia-course-statuses-rl-component";
import { initHitsPerPageWidget } from "./algolia-hits-per-page-component";
import { initHitsWidget } from "./algolia-hits-component";
import { initInfiniteHitsWidget } from "./algolia-infinite-hits-component";
import { initMenuWidget } from "./algolia-menu-component.js";
import { initMenuSelectWidget } from "./algolia-menu-select-component";
import { initPaginationWidget } from "./algolia-pagination-component";
import { initRefinementListWidget } from "./algolia-refinement-list-component";
import { initSearchBoxWidget } from "./algolia-search-box-component";
import { initSortByWidget } from "./algolia-sortby-component";
import { initStatsWidget } from "./algolia-stats-component";

document.addEventListener("DOMContentLoaded", function() {
  // TODO: get all algolia-widget class elements
  //       loop through and check their types
  //       load based on found types
  initClearRefinementsWidget();
  initCourseStatusesRefinementList();
  initHitsPerPageWidget();
  initHitsWidget();
  initInfiniteHitsWidget();
  initMenuWidget();
  initMenuSelectWidget();
  initPaginationWidget();
  initRefinementListWidget();
  initSearchBoxWidget();
  initSortByWidget();
  initStatsWidget();
})